import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, from, map, take } from 'rxjs';
import { DepotMasterTab1 } from 'src/app/models/Depot_Master_Model/depot-master-tab1';
import { BackendListModel } from 'src/app/models/common/list.model';
import { LocationModel } from 'src/app/models/container_master_model/location';
import { DoContact } from 'src/app/models/do-contact';
import { ReleaseOrder, SupplierDOModel } from 'src/app/models/release-order';
import { ReturnContactClass, ReturnContactInfo } from 'src/app/models/return-contact-info';
import { ReturnContainer, ReturnOrderClass } from 'src/app/models/return-container';
import { DomainCodeApiService } from 'src/app/services/domain_code/domain-code-api.service';
import { LocationApiService } from 'src/app/services/domain_code/location-api.service';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';
import { EmbassyService } from 'src/app/services/embassy.service';
import { ReleaseOrderService } from 'src/app/services/release-order.service';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';
import { MatDialog } from '@angular/material/dialog';
import { ApiRoutes } from 'src/app/services/apiroutes';
import { DepotMasterApiService } from 'src/app/services/domain_code/depot-master-api.service';
import { ContainersList } from 'src/app/models/return-container-reference';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { ContainerslistforpickupComponent } from '../containerslistforpickup/containerslistforpickup.component';
import { TermsAndConditionsModel } from 'src/app/models/common/terms-and-conditions.model';
import { QuillEditorComponent } from 'ngx-quill';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { AuthService } from 'src/app/services/auth.service';
import { SendEmailConfirmationComponent } from '../../dialog-box/send-email-confirmation/send-email-confirmation.component';
import { ContactPersonsComponent } from '../../form-fields/contact-persons/contact-persons.component';

@Component({
  selector: 'logzy-return-reference',
  templateUrl: './return-order.component.html',
  styleUrls: ['./return-order.component.scss', '../release-order/release-order.component.scss']
})
export class ReturnOrderComponent implements OnInit {
  errorObj: any = {};
  returnOrder: any;
  @Input()
  addRelease: boolean = false;
  depotSeleted: boolean = false;
  loading: boolean = true;
  isShow: boolean = false;
  isShown: boolean = false;
  isDisabled: boolean = false;
  isCustomer: boolean = false;
  isHide: boolean = true;
  disableSaveButton: boolean = false; // used for button loading
  canvas: string = "Canvas";
  open1: string = "sidepanel";
  bindName = new BehaviorSubject(null);
  @Output() editROrder = new EventEmitter<any>();
  @Output() cancelRetO = new EventEmitter<any>();
  @Output() revalidateRetO = new EventEmitter<any>();
  @Output() revalidateCRetO = new EventEmitter<any>();
  @Output() navigateDropoff = new EventEmitter<any>();
  @Output() openDepotForm = new EventEmitter<any>();

  @ViewChild(ContainerslistforpickupComponent) containersListComponent!: ContainerslistforpickupComponent;

  dd_depotLocation: BackendListModel<LocationModel>;
  // dropOffLocationListUrl = `${this.locationService.base_url}?search=::search::&dropoff_request_id=::request_id::`
  // dropOffLocationListUrlTransforms = {
  //   request_id: ''
  // }

  emptyList: boolean = false;
  depotAddress: any;
  depotContacts: any;
  defaultReturn: any;
  DOOwnerdata: any;
  showCancelled: any
  currentDate = new Date();
  storage_Charge: any;
  deleteExRevalidation: any;
  quoteList;
  returnConObject: ReturnOrderClass;
  defaultReturnContact: any;
  returnContactObject: ReturnContactInfo = {
    id: null,
    is_active: true,
    name: null,
    email: null,
    designation: null,
    contact_no: null,
    mobile_no: null,
    return_details: null,
    type: null
  }
  defaultDepot: DepotMasterTab1 = {
    id: null,
    name: null,
    location_type: '',
    depot_owner_type: null,
    local_name: null,
    address: null,
    agreement_valid_date: null,
    location_billing_type: null,
    location_email: null,
    location_contact_no: null,
    working_hrs_from: null,
    working_hrs_to: null,
    week_offs: null,
    is_edi_available: true,
    edi_code: null,
    remarks: null,
    country: null,
    state: null,
    depot_week_offs: '',
    ports: [],
    connectivities: [],
    free_storage_days_upto_teus: null,
    is_active: true
    // approachable_via:[]
  }
  selectedDepotObj = { ... this.defaultDepot };
  returnOrderResponse: any;

  showDepotDetailsSection: boolean = false;
  addressRequired: boolean = false;
  hasPropertyIsInternational: boolean = false;
  transactionType: string = '';
  requestType: string = '';
  bookingListUrl = '';
  supplierListUrl = '';
  supplierDOListUrl = '';
  requirementListUrl = '';
  dev_value: string = '';
  showAddress: boolean = false;
  isShownOptions: boolean = true;

  selectedSupplierDO: SupplierDOModel = null;

  supplierUrl = ApiRoutes.Booking;

  request_id: string = '';
  containersList;
  selectedContainers = [];
  showContainers: boolean = false;
  pickupTableErrorList: [] = [];
  requirementList: [] = [];

  dropOffLocationListUrl1 = '';
  termsConditionList: TermsAndConditionsModel[] = [];
  termsAndCondition: TermsAndConditionsModel;
  selectedTermsAndCondition: string = '';
  doOwnerId: string = '';

  modules = {};
  @ViewChild('editor', { static: false }) editor: QuillEditorComponent;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(ContactPersonsComponent) contactPersonsComponent: ContactPersonsComponent;

  companyUrl = ApiRoutes.Company;
  showDownloadSchedule: boolean = false;
  containerSizeTypeId: string = '';
  requirement:string;

  constructor(private releaseservice: ReleaseOrderService, private snackBar: MatSnackBar,
    public requestService: RequestApiService, private locationService: LocationApiService,
    private route: ActivatedRoute, private domainService: DomainCodeApiService, private router: Router,
    public embassyService: EmbassyService, private fileDownloadService: FileDownloadService,
    private dialog: MatDialog, private depotMasterApiService: DepotMasterApiService, public authService: AuthService,) {
    this.modules = {
      toolbar: false
    }
  }


  ngOnInit(): void {
    this.isCustomer = this.authService.isCustomer();
    if (this.isCustomer && this.requestService.selectedRequest.transaction_type == 'use') {
      this.isShownOptions = false;
    }
    this.requirementList = [];
    this.dropOffLocationListUrl1 = null;
    this.getAllData();
    this.getAllDOowner();
    this.getTermsAndConditionMasterList();
    this.route.queryParams.subscribe(params => {
      if ('id' in params) {
        this.request_id = params['id']
        this.getRequestDetails(params['id']);
      }
      // if ('type' in params) {
      //   this.transactionType = params['type'];
      // }

      // if ('rtype' in params) {
      //   this.requestType = params['rtype'];
      // }
      this.depotMasterApiService.depotSubject.subscribe(data => {
        // console.log('New Depot received', data);
        this.returnConObject.depot = data;
        this.selectedDepot(this.returnConObject.depot);
      });
    });
    // this.getQuotes(this.requestService.selectedRequest);

  }

  getRequestDetails(id) {
    this.requestService.getRequestDetailsById(id).subscribe({
      next: response => {
        this.requestService.selectedRequest = { ...response };
        this.requirementList = this.requestService.selectedRequest.requirement;
        console.log('ngOnInit --------------------------> ', this.requestService.selectedRequest.requirement);
      }
    });
  }


  getAllData() {
    this.returnConObject = new ReturnOrderClass();
    this.returnConObject.billed_from = this.currentDate;
    let valid_till = new Date(this.currentDate);
    valid_till.setDate(valid_till.getDate() + 21);
    this.returnConObject.valid_till = valid_till;
    this.getQuotes(this.requestService.selectedRequest);

    this.route.queryParams.subscribe(params => {
      if ('id' in params) {
        // this.dropOffLocationListUrlTransforms = {
        //   request_id: params['id']
        // }
        this.getReturnOrderbyReqID(params['id']);
        this.getDepotName(params['id']);
      }

      if ('type' in params) {
        this.transactionType = params['type'];
      }

      if ('rtype' in params) {
        this.requestType = params['rtype'];
      }

    });
  }
  selectedDepot(depot) {
    if (this.returnConObject.do_owner?.id != null) {
      // this.dropOffLocationListUrl1 = `${this.locationService.base_url1}location_short/?search=::search::&dropoff_request_id=${this.requestService.selectedRequest.id}`;
      // &depot_owner_type=${this.returnConObject.do_owner?.id}
    }

    this.depotSeleted = true;
    this.depotAddress = depot?.address;
    this.depotContacts = depot?.contacts;

    if (depot != null) {
      if (depot.id != null) {
        this.closeEdit();
        console.log('this.depotContacts.length', this.depotContacts.length);
        this.showDepotDetailsSection = true;
        if (this.depotContacts.length == 0) {
          this.showAddress = false;
          this.returnConObject.depot_contact_full_name = null;
          this.returnConObject.depot_contact_email = null;
          this.returnConObject.depot_contact_number = null;
        } else {
          // this.returnConObject.depot_contact_full_name = this.depotContacts[0].first_name + ' ' + this.depotContacts[0].last_name;
          this.returnConObject.depot_contact_full_name =
            this.depotContacts[0].first_name != null ? (this.depotContacts[0].last_name != null
              ? `${this.depotContacts[0].first_name} ${this.depotContacts[0].last_name}`
              : this.depotContacts[0].first_name)
              : (this.depotContacts[0].last_name != null
                ? this.depotContacts[0].last_name
                : '');
          this.returnConObject.depot_contact_email = this.depotContacts[0].email;
          this.returnConObject.depot_contact_number = this.depotContacts[0].phone?.as_e164;
          this.showAddress = true;
        }
      } else {
        let depotObj = { ... this.defaultDepot };
        depotObj.name = depot.name_display
        // this.addDepotForm();
        this.openDepotForm.emit(depot);
      }
      this.addressRequired = true;
    }
    if (depot == null) {
      this.returnConObject.depot_contact_full_name = null;
      this.returnConObject.depot_contact_email = null;
      this.returnConObject.depot_contact_number = null;
    }
  }

  selectedAddress(address: []) {
    console.log('address', address)
    if (address != null) {
      if (address.hasOwnProperty('id')) {
        console.log('Has Property Id');
        this.showAddress = false;
        this.hasPropertyIsInternational = false;
      } else {
        console.log('Has Property Is International');
        this.showAddress = true;
        this.hasPropertyIsInternational = true;
      }
    } else {
      this.showAddress = false;
    }
  }

  addDepotForm() {
    this.openDepotForm.emit();
    // this.releaseservice.selectedOrder = { ...item };
  }
  closeEdit() {
    this.open1 = " sidepanel ";
    this.canvas = "Canvas ";
    this.bindName.next(null);
  }


  EditOrder(item, contact) {
    this.editROrder.emit(item);
    console.log("step1", item)
    this.releaseservice.selectedROrder = { ...item, ...contact };
  }
  ReValidateOrder(item) {
    this.revalidateRetO.emit(item);
    this.releaseservice.selectedROrder = { ...item };
  }
  CancelOrder(item) {
    this.cancelRetO.emit(item);
    this.releaseservice.selectedROrder = { ...item };
  }
  ReValidateCustOrder(item) {
    this.revalidateCRetO.emit(item);
    this.releaseservice.selectedROrder = { ...item };
  }

  getDepotName(id) {
    return this.releaseservice.getDepotLocationbyReturnreqID(id).subscribe(
      (response => {
        this.dd_depotLocation = response;
      }));
  }
  getStorageCharge(DId, CId) {
    return this.releaseservice.getStorageChargebyDepotID(DId, this.requestService?.selectedRequest?.requirement[0]?.container_size_type?.size).subscribe(
      (response => {
        this.storage_Charge = response?.results;
        this.returnConObject.storage_charge = this.storage_Charge[0]?.charge_rate;
        this.returnConObject.storage_charge_currency = this.storage_Charge[0]?.charge_rate_currency;
        console.log("this.storage_Charge", this.storage_Charge[0]?.charge_rate);
        console.log("this.storage_Charge Currency", this.storage_Charge[0]?.charge_rate_currency);

      }));
  }
  getAllDOowner() {
    this.showContainers = false;
    return this.domainService.getByGroup('DOOwner').subscribe(
      (response => {
        if (this.transactionType == 'supply') {
          this.DOOwnerdata = response.results[1];
          this.isShown = true;
          this.depotAddress = null;
          this.returnConObject.depot = null;
          // this.dropOffLocationListUrl1 = `${this.locationService.base_url1}location_short/?search=::search::&depot_owner_type=${this.DOOwnerdata.id}&dropoff_request_id=${this.requestService.selectedRequest.id}`;
          this.returnConObject.do_owner = this.DOOwnerdata;
        } else {
          this.DOOwnerdata = response.results;
        } console.log("DOOwnerdata", this.DOOwnerdata);

      }));
  }

  getReturnOrderbyReqID(id) {
    this.releaseservice.getReturnDetailsbyRequestId(id).subscribe({
      next: response => {
        this.returnOrder = response;
        console.log(" this.returnOrder", this.returnOrder)
        this.loading = false;
        if (this.returnOrder.return_list?.length) {
          this.emptyList = false;
          // console.log("this is empty list", this.returnOrder.return_list);
          if (this.returnOrder.return_list.filter(item => item.status == 'Active').length != 0)
            this.showDownloadSchedule = true;
          else
            this.showDownloadSchedule = false;
        }
        else {
          this.emptyList = true;
          // console.log("this is empty list", this.returnOrder.return_list);
          this.showDownloadSchedule = false;
        }
      },
    })
  }
  changeDOowner(event) {
    if (event == null || event == undefined) {
      console.log("event", event)
    }
    else {
      console.log("else event", event);
      this.dev_value = event.dev_value;
      if (event?.id == this.DOOwnerdata[0]?.id) {
        this.isShown = false;
        this.depotAddress = null;
        this.returnConObject.depot = null;
        this.doOwnerId = event?.id;
        this.dropOffLocationListUrl1 = `${this.locationService.base_url1}location_short/?search=::search::&depot_owner_type=${event?.id}&dropoff_requirement_id=${this.returnConObject.requirement?.id}`
        this.containerSizeTypeId = this.returnConObject.requirement.container_size_type.id;
      } else {
        this.isShown = true;
        this.depotAddress = null;
        this.returnConObject.depot = null;
        this.doOwnerId = event?.id;
        this.containerSizeTypeId = null;
        // this.dropOffLocationListUrl1 = `${this.locationService.base_url1}location_short/?search=::search::&depot_owner_type=${event?.id}&dropoff_requirement_id=${this.requestService.selectedRequest.id}`

      }

      this.supplierListUrl = `${this.companyUrl}company_short/?is_internal=0&for_return_request_id=${this.request_id}&search=::search::`
      this.returnConObject.depot = null;
      this.returnConObject.supplier = null;
      this.returnConObject.supply_rr = null;
      this.returnConObject.supply_mappings = null;
      this.returnConObject.depot_contact_email = null;
      this.returnConObject.depot_contact_number = null;
      this.returnConObject.depot_contact_full_name = null;
      this.selectedSupplierDO = null;
      if (this.dev_value == 'arcon')
        this.showContainers = true;
      else
        this.showContainers = false;
    }
  }
  dateChange(billed_from) {
    let valid_till = new Date(billed_from);
    valid_till.setDate(valid_till.getDate() + 21);
    this.returnConObject.valid_till = valid_till;
  }
  postReturnOrder(data) {
    this.pickupTableErrorList = [];
    data['address'] = this.depotAddress;
    console.log(this.dev_value);
    if ((this.requestType == 'one_way' || this.requestType == 'lease' || this.requestType == 'empty_repo') && this.dev_value == 'supplier') {
      data['supply_mappings'] = [];
      data['supply_rr'] = this.selectedSupplierDO ? this.selectedSupplierDO.id : null;
    } else if ((this.requestType == 'one_way' || this.requestType == 'lease' || this.requestType == 'empty_repo') && this.dev_value == 'arcon') {
      data['supply_rr'] = null;
    }

    let contacts = [];

    if (this.transactionType == 'use') {
      this.contactPersonsComponent.contacts.map(contact => {
        contacts.push({
          contact_full_name: contact.contact_name,
          contact_number: contact.contact_number,
          contact_email: contact.contact_email,
          designation: contact.profile_role
        })
      });
    }
    data['contacts'] = contacts;
    console.log("data['contacts']", data['contacts']);

    this.disableSaveButton = true;
    let contact = { ...this.returnContactObject };
    this.releaseservice.postReturnDetails(data).subscribe({
      next: response => {
        // this.postReturnContact(contact, response.id);
        this.snackBar.open("Return Reference created successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        this.returnOrderResponse = response;
        this.isDisabled = true;
        // this.returnConObject = { ... this.defaultReturn };
        this.returnConObject = new ReturnOrderClass();
        this.getAllDOowner();
        this.getAllData();
        this.returnContactObject = { ... this.defaultReturnContact };
        this.disableSaveButton = false;
        this.addRelease = false;
        this.depotContacts = [];
        this.showDepotDetailsSection = false;
        this.showContainers = false;
        if (this.transactionType == 'use') {
          this.contactPersonsComponent.resetContacts();
        }
      },
      error: error => {
        this.disableSaveButton = false;
        if (error.error.quantity) {
          // if (error.error.quantity[0].includes('0'))
          if (this.returnConObject.quantity != null)
            this.openWarning(error.error.quantity[0], '', 'I Understand');
          else
            this.openWarning('Release quantity cannot be null', '', 'I Understand');
        }
        if (error.error.containers) {
          this.pickupTableErrorList = error.error.containers;
          this.openWarning(error.error.containers.map(container => `• ${container}`).join('\n'), '', 'I Understand');
        }
        return this.catchError(error);
      }
    })
  }

  openWarning(label: string, description, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2 }
    });
  }

  postReturnContact(data, relOrderId) {
    data['email'] = data?.contact_no?.email;
    if (data?.contact_no?.first_name != null) {
      data['name'] = data?.contact_no?.first_name + ' ' + data?.contact_no?.last_name;
    }
    data['contact_no'] = data?.contact_no?.phone?.as_international;
    // data['contact_no'] = data?.contact_no;
    data['return_details'] = relOrderId;
    this.releaseservice.postReturnContactInfo(data).subscribe({
      next: response => {
        // this.snackBar.open("Create Return Contact Successfully!", 'Close', {
        //   verticalPosition: 'top',
        //   duration: 2000,
        // });
        this.getReturnOrderbyReqID(this.requestService.selectedRequest.id);
      },
      error: error => {
        return this.catchError(error);
      }
    })
  }

  keysToTransform = [
    'do_owner',
    'upload_document',
    'depot'
  ];

  getContainersList() {
    this.selectedContainers = [];
    this.containersListComponent.selection.selected.forEach(container => this.selectedContainers.push(container.id));
    // console.log('selected containers for dropoff', this.selectedContainers);
  }

  saveOrder() {
    if ((this.transactionType == 'use' && this.dev_value == 'arcon') || this.transactionType == 'supply') {
      this.getContainersList();
      if (this.selectedContainers.length == 0) {
        this.openWarning('Please select at least one container which is yet not returned.', '', 'I Understand');
        return;
      }
    }

    // if (this.showContainers == false && this.dev_value == 'arcon')
    //   this.selectedContainers = [];

    if (this.transactionType == 'use') {
      // console.log('this.contactPersonsComponent.contacts', this.contactPersonsComponent.contacts);
      if (this.contactPersonsComponent.contacts.length == 0) {
        this.openWarning('Please add atleast 1 contact person ', '', 'I Understand');
        return;
      }
      // else {
      //   let contactFlag = false;
      //   this.contactPersonsComponent.contacts.map(contact => {
      //     if (contact.contact_name.trim() == '' || contact.contact_email.trim() == '' || contact.contact_number.trim() == '' || contact.profile_role.trim() == '') {
      //       contactFlag = true;
      //     }
      //   });

      //   if (contactFlag) {
      //     this.openWarning('User Contact Details cannot be empty ', '', 'I Understand');
      //     return;
      //   }
      // }
      let contactFlag = this.contactPersonsComponent.contacts.some(contact =>
        contact.contact_full_name?.trim() === '' ||
        contact.contact_email?.trim() === '' ||
        contact.contact_number?.trim() === '' ||
        contact.designation?.trim() === ''
      );

      if (contactFlag) {
        this.openWarning('User Contact Details cannot be empty', '', 'I Understand');
        return;
      }
    }

    this.returnConObject.containers = this.selectedContainers;

    if (this.returnConObject.billed_from != null && this.returnConObject.valid_till != null) {
      const billed_from = new Date(this.returnConObject.billed_from);
      const utcDate = new Date(billed_from.toUTCString());
      utcDate.setHours(0, 0, 0, 0);
      this.returnConObject.billed_from = utcDate.toISOString();

      const valid_till = new Date(this.returnConObject.valid_till);
      const utcDate1 = new Date(valid_till.toUTCString());
      utcDate1.setHours(0, 0, 0, 0);
      this.returnConObject.valid_till = utcDate1.toISOString();

    }
    console.log(this.returnContactObject.contact_no, this.returnConObject);

    if (this.returnContactObject.contact_no != null) {
      if (this.returnContactObject.contact_no.hasOwnProperty('id')) {
        this.returnConObject.depot_contact_full_name = this.returnContactObject.contact_no.first_name + ' ' + this.returnContactObject.contact_no.last_name;
        this.returnConObject.depot_contact_email = this.returnContactObject.contact_no.email;
        this.returnConObject.depot_contact_number = this.returnContactObject.contact_no.phone.as_international;
      }
    }

    // for (let idx = 0; idx < this.requestService?.selectedRequest?.requirement.length; idx++) {
    //   this.returnConObject.requirement = this.requestService.selectedRequest?.requirement[idx].id;
    // }
    // let payload = { ...this.returnConObject };
    // for (const key of this.keysToTransform) {
    //   if (payload[key] != null && payload[key] != '')
    //     payload[key] = payload[key].id;
    // }
    // payload['requirement'] = this.returnConObject.requirement;
    if (this.transactionType != 'supply') {
      this.returnConObject.terms_and_condition_fk = this.termsAndCondition.id;
      this.returnConObject.terms_and_condition_text = this.selectedTermsAndCondition;
      // this.returnConObject.handling_remarks = this.returnConObject.terms_and_condition_text;
    }
    this.returnConObject.requirement = this.requirement;

    this.postReturnOrder(this.returnConObject.postReturnOrder());

  }
  denyRequest(item) {
    this.releaseservice.deleteExternalRevalidationRObyid(item.external_do_revalidation_request[0].id).subscribe({
      next: response => {
        this.deleteExRevalidation = response;
        this.snackBar.open("Deny External REturn Revalidation Request Successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        this.isHide = false;
        this.getReturnOrderbyReqID(this.requestService.selectedRequest.id);

      },
    })
  }
  navigateDtopoff() {
    this.router.navigateByUrl['']
    this.navigateDropoff.emit('return');
  }
  getQuotes(id) {
    return this.requestService.getlastQuote(id).subscribe(
      (response => {
        this.quoteList = response.results;
        this.returnConObject.storage_charge = this.quoteList[0]?.latest_quote?.dropoff_charge ?? '0';
        this.returnConObject.storage_charge_currency = this.quoteList[0]?.latest_quote?.dropoff_charge_currency ?? 'USD';
        console.log("Storae Charge From Quote", this.quoteList[0]?.latest_quote?.storage_charge)
      }));
  }
  // Function to catch errors
  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    }
  }

  filterSupplierDO(event) {
    if (event != null) {
      // this.supplierDOListUrl = `${this.supplierUrl}do_details_autocomplete/?search=::search::&request_id=${event.id}&for_use_requirement_id=${this.requestService.selectedRequest?.requirement[0].id}`;
      this.returnConObject.depot = null;
      this.returnConObject.supply_mappings = null;
      this.returnConObject.depot_contact_email = null;
      this.returnConObject.depot_contact_number = null;
      this.returnConObject.depot_contact_number = null;
      this.showDepotDetailsSection = false;
      this.returnConObject.supply_rr = null;
      this.selectedSupplierDO = null;
      this.supplierDOListUrl = `${this.supplierUrl}return_details_autocomplete/?search=::search::&requestor_company_id=${event.id}`;
    }
  }

  loadSupplierAddress(event) {
    if (event != null) {
      this.selectedSupplierDO = event;
      console.log(this.selectedSupplierDO);
      this.returnConObject.depot_contact_full_name = event.depot_contact_full_name;
      this.returnConObject.depot_contact_email = event.depot_contact_email;
      this.returnConObject.depot_contact_number = event.depot_contact_number;
      this.returnConObject.storage_charge = event.storage_charge;
      this.returnConObject.storage_charge_currency = event.storage_charge_currency;
      this.returnConObject.billed_from = event.billed_from;
      this.returnConObject.valid_till = event.valid_till;
      this.returnConObject.return_reference_no = event.return_reference_no

      this.showDepotDetailsSection = true;
      this.returnConObject.depot = event.depot;
      if (this.selectedSupplierDO.return_container_references.length != 0) {
        this.selectedContainers = [];
        this.selectedSupplierDO.return_container_references.forEach(container => this.selectedContainers.push(container?.container));
      }
    }
  }

  loadDO(item) {
    // console.log(item.supply_rr.request.id, item.supply_rr.request.transaction_type, item.supply_rr.request.request_type.dev_name);
    window.open(`/requests/request-processing/request-details?id=${item.supply_rr.request.id}&type=${item.supply_rr.request.transaction_type}&rtype=${item.supply_rr.request.request_type.dev_name}&mode=rr`, '_blank');
  }

  generateDropOffSchedule() {
    const fileUrl = this.supplierUrl + 'return_schedule_excel/' + this.request_id + '/';
    const fileName = 'DropOffSchedule.xlsx'; // Replace with the desired file name
    this.fileDownloadService.downloadFile(fileUrl, fileName);
  }

  onRequirementChange(event) {
    this.showContainers = false;
    if (event == null) {
      this.showDepotDetailsSection = false;
      this.dropOffLocationListUrl1 = null;
      this.containerSizeTypeId = null;
    } else {
      this.showDepotDetailsSection = false;
      this.dropOffLocationListUrl1 = `${this.locationService.base_url1}location_short/?search=::search::&depot_owner_type=${this.DOOwnerdata.id}&dropoff_requirement_id=${this.returnConObject.requirement?.id}`
      this.containerSizeTypeId = event.container_size_type.id;
      this.showContainers = true;
      this.requirement = event.requirement;
        if(this.returnConObject.requirement.storage_charge!=null){
                this.returnConObject.storage_charge = this.returnConObject.requirement.storage_charge;
                this.returnConObject.storage_charge_currency = this.returnConObject.requirement.storage_charge_currency;
            }
            else{
                this.getStoragechargebyReqId(this.requirement);
        }
    }
    this.returnConObject.depot = null;
  }

  onRequirementChangeUse(event) {
    if (event == null) {
      this.showDepotDetailsSection = false;
      this.dropOffLocationListUrl1 = null;
      this.containerSizeTypeId = null;
      this.showContainers = false;
      this.returnConObject.depot = null;
    } else {
      this.showDepotDetailsSection = false;
      this.returnConObject.depot = null;
      this.dropOffLocationListUrl1 = `${this.locationService.base_url1}location_short/?search=::search::&depot_owner_type=${this.doOwnerId}&dropoff_requirement_id=${this.returnConObject.requirement.requirement?.id}`
      this.containerSizeTypeId = event.container_size_type.id;
      this.requirement = event.requirement;

      if (this.returnConObject.requirement.storage_charge != null) {
        this.returnConObject.storage_charge = this.returnConObject.requirement.storage_charge;
        this.returnConObject.storage_charge_currency = this.returnConObject.requirement.storage_charge_currency;
      }
      else {
        this.getStoragechargebyReqId(this.requirement);
      } 
      if (this.dev_value == 'arcon')
        this.showContainers = true;
      else
        this.showContainers = false;
    }
  }

  showSelectedTermsAndCondition() {
    if (this.termsConditionList.length != 0) {
      this.termsConditionList.map(item => {
        if (item.id == this.termsAndCondition) {
          this.termsAndCondition = {
            id: item.id,
            name: item.name
          };
          this.selectedTermsAndCondition = item.terms_condition;
        }
      })
    }
  }

  getTermsAndConditionMasterList() {
    this.requestService.getTermsAndConditionsListDO(this.requestService.selectedRequest, 'return reference').subscribe({
      next: response => {
        this.termsConditionList = response.results;
        if (this.termsConditionList.length != 0) {
          this.termsAndCondition = {
            id: this.termsConditionList[0].id,
            name: this.termsConditionList[0].name
          };
          this.selectedTermsAndCondition = this.termsConditionList[0].terms_condition;
        }
        return response;
      },
      error: error => {
        console.log(error)
        return error;
      }
    })
  }
  getStoragechargebyReqId(reqId) {
    this.requestService.getStorageChargebyRequirementId(reqId).subscribe({
      next: response => {
        this.requirementListUrl = response;
        this.returnConObject.storage_charge = response.storage_charge;
        if (this.returnConObject.storage_charge != null) {
          this.returnConObject.storage_charge_currency = response.storage_charge_currency;
        }
        else {
          this.returnConObject.storage_charge_currency = 'USD';
        }
        console.log("this.requirementListUrl", this.requirementListUrl)
      }
    })
  }

  openSendConfirmationDialog(item, snackBarMessage, mailType): void {
    console.log(item);
    let htmlContent: string = '';
    this.requestService.getEmailContent(item.id, mailType).subscribe(
      (response: string) => {
        htmlContent = response;
        const dialogData = {
          usersList: [this.requestService.selectedRequest.requestor?.email],
          userListKey: '',
          contentURL: ApiRoutes.QuoteConfirmEmailUrl,
          contentKeys: {
            to_emails: '',
            subject: 'Release order generated for ' + item?.do_reference_no,
            content: htmlContent
          },
          mailType: mailType,
          snackBarMessage: snackBarMessage

        };
        const dialogRef = this.dialog.open(SendEmailConfirmationComponent, {
          width: '80%', // Set the width of the dialog
          disableClose: true,
          data: dialogData
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            console.log('User clicked Yes');
            this.disableSaveButton = false;
          } else {
            this.disableSaveButton = false;
          }
          // window.location.reload();
        });

        dialogRef.componentInstance.emailSend.subscribe(() => {
          this.snackBar.open("Return order shared on email", 'Close', {
            verticalPosition: 'top',
            duration: 2000,
          });
        });
      },
      (error) => {
        console.error('Error fetching HTML content:', error);
      }
    );
  }
}
